export const EVENTS = {
  RESYNC_REQUESTED: 'habitica::resync-requested',
  RESYNC_COMPLETED: 'habitica::resync-completed',

  PM_REFRESH: 'pm::refresh',

  BANNER_HEIGHT_UPDATED: 'banner:height_updated',
  WORLD_STATE_LOADED: 'habitica:world-state-loaded',
};
